exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".E3HKAXY66AGN1h-zpg76K>a._2A1JuBCvp0dzAWAWJjY9mQ{margin:20px 0px 0px 0px}.E3HKAXY66AGN1h-zpg76K>a._1FaNv8-Ft_sGfUmOs4gIjw{margin:10px 0px 0px 0px}.E3HKAXY66AGN1h-zpg76K>a._1ti78As6cnGnY5tP-enzzW{padding-bottom:0px}.phbafVF8QsFek-g9cJbiE{display:flex;flex-direction:row nowrap;justify-content:space-between}._1Fk5TDxOzOrq7DHhEBe167>:last-child{margin-bottom:0px}._3r_y3q_mobzxTYRfNnXV41{margin-bottom:20px}._3r_y3q_mobzxTYRfNnXV41>:last-child{margin-top:5px}._3r_y3q_mobzxTYRfNnXV41>a.SkLi9jAdw9nSL66WbKskx{color:#212121;text-decoration:none}.SkLi9jAdw9nSL66WbKskx{font-size:20px;font-weight:500;line-height:22px;margin-bottom:10px}.YHnPAwHbkHWk1b1cX_oAl{color:#616161}.IRbPxP0pvIb8XixoVRUUH{font-style:italic}\n", ""]);

// Exports
exports.locals = {
	"contactUs": "E3HKAXY66AGN1h-zpg76K",
	"contactUsTop": "_2A1JuBCvp0dzAWAWJjY9mQ",
	"contactUsMiddle": "_1FaNv8-Ft_sGfUmOs4gIjw",
	"contactUsBottom": "_1ti78As6cnGnY5tP-enzzW",
	"socialCard": "phbafVF8QsFek-g9cJbiE",
	"articles": "_1Fk5TDxOzOrq7DHhEBe167",
	"article": "_3r_y3q_mobzxTYRfNnXV41",
	"articleTitle": "SkLi9jAdw9nSL66WbKskx",
	"articleGrey": "YHnPAwHbkHWk1b1cX_oAl",
	"articleUrl": "IRbPxP0pvIb8XixoVRUUH"
};